import React, { useState } from 'react';
import axios from 'axios';

export const FacturaCompleta = ({ empresa, usuarioToken }) => {
  const [form, setForm] = useState({
    cif: empresa?.notasEmpresa ? JSON.parse(empresa.notasEmpresa)?.verifactu?.cif || '' : '',
    numero: '',
    fecha: '',
    tipo_factura: 'F1',
    is_simplificada: false,
    is_intracomunitaria: false,
    is_exportacion: false,
    recargo: false,
    subtotal: null,
    total: null,
    nombreFacturacion: '',
    cifFacturacion: '',
    direccionFacturacion: '',
    cpFacturacion: '',
    localidad_facturacion: '',
    provincia_facturacion: '',
  });

  const [lineas, setLineas] = useState([
    { producto: '', cantidad: null, precio: null, impuesto: null, recargo: null, descuento: null },
  ]);

  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleLineaChange = (index, field, value) => {
    const nuevasLineas = [...lineas];
    nuevasLineas[index][field] = value;
    setLineas(nuevasLineas);
  };

  const agregarLinea = () => {
    setLineas([...lineas, { producto: '', cantidad: null, precio: null, impuesto: null, recargo: null, descuento: null}]);
  };

  const quitarLinea = (index) => {
    const nuevasLineas = lineas.filter((_, i) => i !== index);
    setLineas(nuevasLineas);
  };

  const enviarFactura = async () => {
    setLoading(true);
    setMensaje('');

    try {
      const payload = {
        factura: { ...form, version: '1.0' },
        lineas,
      };

      const res = await axios.post(
        'https://facturas-service.cedesa.es/api/v1/subir-factura',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.REACT_APP_VERIFACTU_API_KEY,
          },
        }
      );

      setMensaje('Factura enviada correctamente.');
    } catch (err) {
      console.error(err);
      setMensaje('Error al enviar la factura.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-8 p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-4">Crear Factura Completa</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          type="text"
          placeholder="CIF"
          value={form.cif}
          disabled
          className="border p-2 rounded bg-gray-100 cursor-not-allowed"
        />
        <input
          type="text"
          placeholder="Número"
          value={form.numero}
          onChange={(e) => setForm({ ...form, numero: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="date"
          placeholder="Fecha"
          value={form.fecha}
          onChange={(e) => setForm({ ...form, fecha: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Tipo de factura"
          value={form.tipo_factura}
          onChange={(e) => setForm({ ...form, tipo_factura: e.target.value })}
          className="border p-2 rounded"
          disabled
        />
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={form.is_intracomunitaria}
            onChange={(e) => setForm({ ...form, is_intracomunitaria: e.target.checked })}
          />
          <label>Intracomunitaria</label>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={form.is_exportacion}
            onChange={(e) => setForm({ ...form, is_exportacion: e.target.checked })}
          />
          <label>Exportación</label>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={form.recargo}
            onChange={(e) => setForm({ ...form, recargo: e.target.checked })}
          />
          <label>Recargo</label>
        </div>
        <input
          type="number"
          placeholder="Subtotal"
          value={form.subtotal}
          onChange={(e) => setForm({ ...form, subtotal: parseFloat(e.target.value) })}
          className="border p-2 rounded"
        />
        <input
          type="number"
          placeholder="Total"
          value={form.total}
          onChange={(e) => setForm({ ...form, total: parseFloat(e.target.value) })}
          className="border p-2 rounded"
        />
      </div>

      <h3 className="text-xl font-semibold mb-2">Datos de facturación</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          type="text"
          placeholder="Nombre"
          value={form.nombreFacturacion}
          onChange={(e) => setForm({ ...form, nombreFacturacion: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="CIF"
          value={form.cifFacturacion}
          onChange={(e) => setForm({ ...form, cifFacturacion: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Dirección"
          value={form.direccionFacturacion}
          onChange={(e) => setForm({ ...form, direccionFacturacion: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Código Postal"
          value={form.cpFacturacion}
          onChange={(e) => setForm({ ...form, cpFacturacion: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Localidad"
          value={form.localidad_facturacion}
          onChange={(e) => setForm({ ...form, localidad_facturacion: e.target.value })}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Provincia"
          value={form.provincia_facturacion}
          onChange={(e) => setForm({ ...form, provincia_facturacion: e.target.value })}
          className="border p-2 rounded"
        />
      </div>

      <h3 className="text-xl font-semibold mb-2">Líneas de factura</h3>
      {lineas.map((linea, idx) => (
        <div key={idx} className="grid grid-cols-1 md:grid-cols-6 gap-2 mb-2">
          <input
            type="text"
            placeholder="Producto"
            value={linea.producto}
            onChange={(e) => handleLineaChange(idx, 'producto', e.target.value)}
            className="border p-2 rounded col-span-2"
          />
          <input
            type="number"
            placeholder="Cantidad"
            value={linea.cantidad}
            onChange={(e) => handleLineaChange(idx, 'cantidad', parseFloat(e.target.value))}
            className="border p-2 rounded"
          />
          <input
            type="number"
            placeholder="Precio"
            value={linea.precio}
            onChange={(e) => handleLineaChange(idx, 'precio', parseFloat(e.target.value))}
            className="border p-2 rounded"
          />
          <input
            type="number"
            placeholder="Impuesto"
            value={linea.impuesto}
            onChange={(e) => handleLineaChange(idx, 'impuesto', parseFloat(e.target.value))}
            className="border p-2 rounded"
          />
          <input
            type="number"
            placeholder="Recargo"
            value={linea.recargo}
            onChange={(e) => handleLineaChange(idx, 'recargo', parseFloat(e.target.value))}
            className="border p-2 rounded"
          />
          <input
            type="number"
            placeholder="Descuento"
            value={linea.descuento}
            onChange={(e) => handleLineaChange(idx, 'descuento', parseFloat(e.target.value))}
            className="border p-2 rounded"
          />
          <button onClick={() => quitarLinea(idx)} className="bg-red-500 text-white px-2 rounded">X</button>
        </div>
      ))}
      <button onClick={agregarLinea} className="bg-blue-500 text-white px-4 py-2 rounded mb-4">Añadir línea</button>

      <button
        onClick={enviarFactura}
        disabled={loading}
        className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
      >
        {loading ? 'Enviando...' : 'Enviar factura'}
      </button>

      {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
    </div>
  );
};
